import { ModalV3 } from '@jouzen/ecom-components';
import { useState } from 'react';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import type { UseWizardState } from '@/app/[locale]/product/_hooks/useWizardState/types';

import EmailFormContent from './EmailFormContent';
import EmailSubmittedContent from './EmailSubmittedContent';

const NotifyMeModal = (): JSX.Element => {
  const { notifyModal, setNotifyModal }: UseWizardState =
    useWizardStateContext();
  const [emailSubmitted, setEmailSubmitted] = useState<boolean>(false);

  return (
    <>
      <ModalV3
        blur={false}
        data-cy="inventoryModal"
        isOpen={notifyModal}
        onOpenChange={setNotifyModal}
        padding="large"
        rounded
        size="small"
      >
        <EmailFormContent setEmailSubmitted={setEmailSubmitted} />
      </ModalV3>
      <ModalV3
        blur={false}
        data-cy="inventoryModal"
        isOpen={emailSubmitted}
        onOpenChange={setEmailSubmitted}
        padding="large"
        rounded
        size="small"
      >
        <EmailSubmittedContent onClick={setEmailSubmitted} />
      </ModalV3>
    </>
  );
};
export default NotifyMeModal;
